import { useCallback } from 'react'
import { NavigateOptions, useNavigate as useNavigateReact } from 'react-router-dom'

export const useNavigate = () => {
  const navigateReact = useNavigateReact()
  const navigate = useCallback(
    (to: string, options?: NavigateOptions) => {
      if (window.location.pathname !== to) {
        navigateReact(to, options)
      }
    },
    [navigateReact]
  )
  return navigate
}
